import Logo from "../../assets/VersusLogo.svg";
import Social from "../../components/Social/Socials";
// import Nav from "../../components/Nav/Nav";
import Tire from "../../assets/tire.svg";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer>
      <div className="footer_container">
        <div className="footer-logo">
          <img src={Logo} alt="Versus Race Team" />
        </div>
        <div className="footer-info">
          <img src={Tire} alt="tire" />
          <p>
            Versus Cycling Collective is a 5o1c3 Registered in the State of
            Minnesota
          </p>
        </div>
        <div className="socials-icons">
          <Social />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
